import { combineReducers } from 'redux';
import reportReducer from './reportReducer';
import authReducer from './authReducer';

export default combineReducers({
  auth: authReducer,
  report: reportReducer,
});
